import React from 'react'

class Rotation extends React.Component {
    render(){

        let rotation = this.props.rotation.map((competitor, index) => {
            
            /* Change color if competitor wasn't fit */
            let localColor = ''
            if(!competitor.apto)
                localColor = 'red'

            /* Change width to remove scoreboard */
            let localWidth = '40%'
            if(!this.props.isScoreMan)
                localWidth = '50%'

            /* Check if it is necessary break line right after 2 competitors */
            if(index % 2 === 0){
                return(
                    <div key={index} className='scoreManLine01' style={{ width: localWidth }}>
                        <div style={{float: 'left', width: '3%'}}>{index / 2 + 1}.</div>
                        <div
                            className='confrontationsLine02'
                            style={{ color: localColor }}
                        >
                            {competitor.nome}&nbsp;
                        </div>
                        X
                    </div>
                )
            } else {
                return(
                    <div key={index}>
                        <div className='scoreManLine01' style={{ width: localWidth }}>
                            <div
                                className='confrontationsLine02'
                                style={{ color: localColor }}
                            >
                                {competitor.nome}&nbsp;
                            </div>
                        </div>
                        <div style={{ clear: 'both' }}></div>
                    </div>
                )
            }
        })

		return(
			<div>
				<div id='rotationsBlockWithCompetitors' className="switchingTitle">
                    {rotation}

                    <div style={{ clear: 'both' }}></div>
                    
                    { this.props.isScoreMan || this.props.isCoord ?
                        <div></div> :
                        <div>
                            <div className='rotationRanking'>
                                <b>Competidores</b> <br /><br />
                                {(this.props.ranking[0] !== '' ? 'Primeiro lugar: ' + this.props.ranking[0] + ' (9 pontos)' : null )} <br /><br />
                                {(this.props.ranking[1] !== '' ? 'Segundo lugar: ' + this.props.ranking[1] + ' (3 pontos)' : null )} <br /><br />
                                {(this.props.ranking[2] !== '' ? 'Terceiro lugar: ' + this.props.ranking[2] + ' (1 ponto)' : null )}
                            </div>

                            <div className='rotationRanking'>
                                <b>Equipes</b> <br /><br />
                                {(this.props.arrayOfTeamsWithScore[0] !== undefined ? this.props.arrayOfTeamsWithScore[0].team + ' | Pontos: ' + (isNaN(this.props.arrayOfTeamsWithScore[0].score) ? 0 : this.props.arrayOfTeamsWithScore[0].score) : null)} <br /><br />
                                {(this.props.arrayOfTeamsWithScore[1] !== undefined ? this.props.arrayOfTeamsWithScore[1].team + ' | Pontos: ' + (isNaN(this.props.arrayOfTeamsWithScore[1].score) ? 0 : this.props.arrayOfTeamsWithScore[1].score) : null)} <br /><br />
                                {(this.props.arrayOfTeamsWithScore[2] !== undefined ? this.props.arrayOfTeamsWithScore[2].team + ' | Pontos: ' + (isNaN(this.props.arrayOfTeamsWithScore[2].score) ? 0 : this.props.arrayOfTeamsWithScore[2].score) : null)}
                            </div>

                            <div style={{ clear: 'both' }}></div>
                        </div>
                    }
                </div>
			</div>
		)
	}
}

export default Rotation